import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'; 
import { theme } from 'utils/theme';
import Header from './HeaderWithoutIcon/Header';  // Import the Header component
import Footer from './Footer/index';  // Import the Footer component

const RegistrationSuccess = () => {
  const navigate = useNavigate(); 
  const [countdown, setCountdown] = useState(10); // State for countdown

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate('/'); 
    }, 10000);

    return () => {
      clearInterval(timer); // Clear countdown interval if component unmounts
      clearTimeout(redirectTimer); // Clear redirect timeout if component unmounts
    };
  }, [navigate]); // Dependency array updated

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Header />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
          textAlign="center"
          p={4}
        >
          <Typography variant="h4" fontWeight={700} mb={2}>
            Thank you!
          </Typography>
          <Typography variant="body1" mb={2}>
            Please verify your account by clicking on the verification link sent to your email.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Redirecting to the home page in {countdown} seconds...
          </Typography>
        </Box>
        <Footer />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default RegistrationSuccess;
